import React, { forwardRef } from 'react';
import { Box, CloseButton as ChakraCloseButton, ModalCloseButton as ChakraModalCloseButton, useStyles } from '@chakra-ui/react';
import { CircleAlert, X } from 'lucide-react';

// Keep Chakra's dismissal, focus handling, sizes and theme while sharing Lucide glyphs.
export const CloseButton = forwardRef((props, ref) => (
  <ChakraCloseButton {...props} ref={ref}><X width="1em" height="1em" aria-hidden="true" focusable="false" /></ChakraCloseButton>
));
CloseButton.displayName = 'LucideCloseButton';

export const ModalCloseButton = forwardRef((props, ref) => (
  <ChakraModalCloseButton {...props} ref={ref}><X width="1em" height="1em" aria-hidden="true" focusable="false" /></ChakraModalCloseButton>
));
ModalCloseButton.displayName = 'LucideModalCloseButton';

export function AlertIcon(props) {
  const styles = useStyles();
  return <Box as="span" display="inherit" __css={styles.icon} {...props} aria-hidden="true">
    <CircleAlert width="100%" height="100%" focusable="false" />
  </Box>;
}
